import React, { TableHTMLAttributes } from 'react';
import TriangleCaretIcon from 'components/Icons/TriangleCaretIcon';
import { SortDirection } from 'types';
import styles from './AGTableWrapper.module.css';

export function SortableHeader<T extends string>({
    label,
    column,
    activeColumn,
    direction,
    onSortChange,
}: {
    label: string;
    column: T;
    activeColumn: T | null;
    direction: SortDirection;
    onSortChange: (column: T) => void;
}) {
    const isActive = activeColumn === column;
    const upColor = isActive && direction === 'asc' ? 'var(--ag-sand-12)' : 'var(--ag-sand-8)';
    const downColor = isActive && direction === 'desc' ? 'var(--ag-sand-12)' : 'var(--ag-sand-8)';
    const ariaSort = isActive ? (direction === 'asc' ? 'ascending' : 'descending') : 'none';

    return (
        <th className={styles.sortableTh} aria-sort={ariaSort}>
            <button type="button" className={styles.sortableHeader} onClick={() => onSortChange(column)}>
                {label}
                <span className={styles.sortCaretStack}>
                    <TriangleCaretIcon direction="up" color={upColor} />
                    <TriangleCaretIcon direction="down" color={downColor} />
                </span>
            </button>
        </th>
    );
}

const AGTAbleWrapper: React.FC<TableHTMLAttributes<HTMLTableElement>> = ({ children, ...restProps }) => {
    const additionalClass = restProps.className ? ` ${restProps.className}` : '';

    return (
        <table {...restProps} className={`${styles.agTableWrapper}${additionalClass}`}>
            {children}
        </table>
    );
};

export default AGTAbleWrapper;
